import { detect } from 'detect-browser';
export const UNKNOWN_INFO = 'unknown';
function browserInfo() {
    const browser = detect();
    return {
        name: (browser === null || browser === void 0 ? void 0 : browser.name) || UNKNOWN_INFO,
        os: (browser === null || browser === void 0 ? void 0 : browser.os) || UNKNOWN_INFO,
        version: (browser === null || browser === void 0 ? void 0 : browser.version) || UNKNOWN_INFO,
    };
}
let version;
const DeviceInfo = {
    getManufacturer: () => Promise.resolve(browserInfo().os),
    getModel: () => browserInfo().name,
    getSystemVersion: () => browserInfo().version,
    getVersion: () => version || UNKNOWN_INFO,
    setVersion: (v) => { version = v; },
};
export default DeviceInfo;
//# sourceMappingURL=DeviceInfo.web.js.map